// eslint-disable-next-line import/prefer-default-export
export { default as MetaData } from './MetaData'
